import { initialState } from "./state"

export default {
  setBank: (state, payload) => (state.bank = payload),
  setBankName: (state, payload) => (state.bankName = payload),
  setAgency: (state, payload) => (state.agency = payload),
  setAccount: (state, payload) => (state.account = payload),
  setWhatsapp: (state, payload) => (state.whatsapp = payload),
  setClientType: (state, payload) => (state.clientType = payload),
  setContractType: (state, payload) => (state.contractType = payload),
  setContractModel: (state, payload) => (state.contractModel = payload),
  setUuid: (state, payload) => (state.uuid = payload),
  setBillingAddress: (state, payload) => {
    Object.keys(state.billingAddress).forEach(key => {
      if (payload[key] !== undefined) {
        state.billingAddress[key] = payload[key]
      }
    })
  },
  setComplements: (state, payload) => (state.complements = payload),
  updateComplement: (state, payload) => {
    state.complements[payload.index][payload.key] = payload.value
  },
  setProviderAddressUuid: (state, payload) =>
    (state.providerAddressUuid = payload),
  resetBillingAddress: state => {
    state.billingAddress = initialState().billingAddress
    state.complements = []
  },
  resetBilling: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
